module.exports = __webpack_public_path__ + "img/acl.917678f5.png";